import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all technicianses
export const getTechnicians = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/technicians`);
    return response.data;
  } catch (error) {
    console.error("Error fetching technicians:", error.response?.data || error);
    throw error;
  }
};

// GET a single technicians
export const getTechniciansById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/technicians/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching technicians:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new technicians
export const createTechnicians = async (techniciansData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/technicians`, techniciansData);
    return response.data;
  } catch (error) {
    console.error("Error creating technicians:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing technicians
export const updateTechnicians = async (id, techniciansData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/technicians/${id}`, techniciansData);
    return response.data;
  } catch (error) {
    console.error("Error updating technicians:", error.response?.data || error);
    throw error;
  }
};

// DELETE a technicians
export const deleteTechnicians = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/technicians/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting technicians:", error.response?.data || error);
    throw error;
  }
};
